<template>
  <DeckControlButton class="p-3" data-testid="non-av-end-session-btn" @click="$emit('click')">
    <XMarkIcon class="w-6 h-6" />
  </DeckControlButton>
</template>

<script lang="ts" setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'

defineEmits(['click'])
</script>
